import { render, staticRenderFns } from "./budget-forms-copy-data.vue?vue&type=template&id=13074c38&scoped=true&"
import script from "./budget-forms-copy-data.vue?vue&type=script&lang=ts&"
export * from "./budget-forms-copy-data.vue?vue&type=script&lang=ts&"
import style0 from "./budget-forms-copy-data.vue?vue&type=style&index=0&id=13074c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13074c38",
  null
  
)

export default component.exports